import { render, staticRenderFns } from "./TraxUiVerticalDynamicTabs.vue?vue&type=template&id=8fc05a8a"
import script from "./TraxUiVerticalDynamicTabs.vue?vue&type=script&lang=js"
export * from "./TraxUiVerticalDynamicTabs.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports